import React from 'react';

import { CookieBanner } from '@spark';

import { PRIVACY_POLICY_PATH } from '@/features/legal';

import { useCookieConsent } from '../hooks/useCookieConsent';

/**
 * Bottom-right cookie banner (Figma MVP-DESIGNES 9496:18744), mounted once
 * at the app root so it shows on every page, login and onboarding included.
 * "More info" opens the in-app Privacy Policy in a new tab so the person
 * keeps the page they were on.
 */
export default function CookieConsentBanner() {
    const { visible, accept, reject, dismiss } = useCookieConsent();
    if (!visible) return null;
    return (
        <CookieBanner
            moreInfoHref={PRIVACY_POLICY_PATH}
            onAccept={accept}
            onReject={reject}
            onClose={dismiss}
        />
    );
}
